<app-book-info />
<app-library-navigation cdkScrollable acpScrollShadow/>
<app-pages-nav />
